import React from 'react';
import { GraduationCap } from 'lucide-react';
import { Card, CardContent } from './ui/card';
import { useTranslation } from 'react-i18next';

const Education = () => {
  const { t } = useTranslation();
  return (
    <section id="education" className="bg-background text-foreground transition-colors duration-300 py-20 px-4 sm:px-6 lg:px-8">
      <div className="max-w-6xl mx-auto">
        
        {/* Encabezado de la sección */}
        <div className="mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-slate-900 dark:text-white mb-4" style={{ fontFamily: 'IBM Plex Sans, sans-serif' }}>
            {t('education.title')}
          </h2>
          <div className="w-20 h-1 bg-blue-600 rounded"></div>
        </div>

        {/* Tarjeta de Educación */}
        <Card className="bg-white dark:bg-slate-900/90 border-slate-200 dark:border-slate-800 hover:shadow-lg transition-all duration-300">
          <CardContent className="p-6 md:p-8">
            <div className="flex items-start gap-4">
              
              {/* Contenedor del ícono */}
              <div className="p-3 bg-blue-100 dark:bg-blue-950/60 rounded-lg mt-1">
                <GraduationCap className="text-blue-600 dark:text-blue-400" size={28} />
              </div>

              {/* Información académica */}
              <div className="flex-1">
                <h3 className="text-xl md:text-2xl font-bold text-slate-900 dark:text-white mb-2">
                  {t('education.degree')}
                </h3>
                <p className="text-lg text-blue-600 dark:text-blue-400 font-medium mb-2">
                  {t('education.university')}
                </p>
                <span className="text-sm text-slate-500 dark:text-slate-400" style={{ fontFamily: 'Roboto Mono, monospace' }}>
                  {t('education.period')}
                </span>
              </div>

            </div>
          </CardContent>
        </Card>

      </div>
    </section>
  );
};

export default Education;